import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { formatDate } from '@angular/common';
import Swal from 'sweetalert2';
import { LocalStorageService } from 'ngx-webstorage';
import { MatDialog } from '@angular/material/dialog';
import { LkpExpenssesService } from 'src/app/services/LkpExpenssesService';
import { LkpExpenssesModel } from 'src/app/models/LkpExpenssesModel';
import { TranslateService } from '@ngx-translate/core';
import { ExpensesSearchComponent } from '../expenses-search/expenses-search.component';
import swal from 'sweetalert2';

@Component({
  selector: 'app-expenses-type',
  templateUrl: './expenses-type.component.html',
  styleUrls: ['./expenses-type.component.css']
})
export class ExpensesTypeComponent implements OnInit {
  expcode = '' ;
  expname = '' ;
  expnotes = '' ;
  compcode = '' ;
  userid = '' ;
  modifieddate = '2022-01-01' ;
  constructor(public expensesservice : LkpExpenssesService,
    public expenses : LkpExpenssesModel,
    public translate: TranslateService,
    public storage: LocalStorageService,
    private dialogref: MatDialog) { }

  ngOnInit(): void {
    this.translate.use('ar');
    document.documentElement.dir = "rtl";
  }
  switchArabic(){
    this.translate.use('ar');
    document.documentElement.dir = "rtl";
  }
  switchEnglish(){
    this.translate.use('en');
    document.documentElement.dir = "ltr";
  }
  openDialog(){
    const dialogRef = this.dialogref.open(ExpensesSearchComponent,
      {
        data: {
          dataKey: this.expenses
        }
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {
        this.expcode = result.expcode;
        this.expname = result.expname;
        this.expnotes = result.expnotes;
        dialogSubmitSubscription.unsubscribe();
      });

  }

  retriveExpenses(){
    this.expensesservice.GetExpenses(this.expcode, this.storage.retrieve('stgcompCode')).subscribe(
      (data: LkpExpenssesModel) => {
        this.expname = data.expname;
        this.expnotes = data.expnotes;
        this.userid = data.userid;
        this.modifieddate = data.modifieddate;
        this.compcode = data.compcode;

      }
    );
  }
  submitExpenses(){
    if (this.expcode == '' || this.expcode == null) {
      return;
    }

    this.expenses.expcode = this.expcode;
    this.expenses.expname = this.expname;
    this.expenses.expnotes = this.expnotes;

    this.expenses.userid = this.storage.retrieve('stguserId');
    this.expenses.modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.expenses.compcode = this.storage.retrieve('stgcompcode');
    this.expensesservice.AddExpenses(this.expenses).subscribe(data => {
    this.mesgSave();
    },
      error => { alert(error); }
    );
  }
  DeleteExpenses(){
    this.expensesservice.DelExpenses(this.expcode, this.storage.retrieve('stgcompCode')).subscribe(
      (data: LkpExpenssesModel) => {
      }
    );
    this.NewData();
  }
  MesgDelete(){
    swal({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then(
      () => {
        this.DeleteExpenses();
        swal('Deleted!', 'Your record has been deleted.', 'success');
      },
      function (dismiss) {
        if (dismiss === 'cancel') {
          swal('Cancelled', 'Your record is safe :)', 'error');
        }
      }
    );
  }
  NewData(){
    this.expcode = '';
    this.expname='';
    this.expnotes='';
  }
  mesgSave() {
    Swal({
    title: 'Your work has been saved',

    type: 'success',
    showConfirmButton: false,

    timer: 1500
    });
  }

}
